export const semanticTokens = {
  colors: {
    'chakra-body-text': { _light: 'gray.800' },
  },
};
